export default __webpack_public_path__ + "static/shippobotham-f85367a8ffc67e8fdd27dd0f366d1a34.jpg";